import * as actions from "../actions";
import * as actionsTypes from "../actionTypes";
import {all, fork, put, takeEvery} from "redux-saga/effects";
import AuthService from "../../services/auth.service";
import HttpService from "../../services/http.service";

function* loginStart(action) {
  // 
  try {
    const response = yield AuthService.login({
      email: action.payload.email,
      password:action.payload.password
    });
    // 
    if (response.data.data.access_token) {
      // 
      HttpService.setToken(response.data.data.access_token);//set token in header
      let user = response?.data?.data?.user || {}; 
      HttpService.setUser(user._id);// set userId and role in header
      //
      localStorage.setItem('userss', JSON.stringify(user)); 
      yield put(actions.loginSuccess(response.data.data));
    } else {
      yield put(actions.loginFailure("Invalid Username/Password"));
    }
  } catch (err) {
    yield put(actions.loginFailure('Invalid Username/Password'));
  }
}

function* loginStartSaga() {
  yield takeEvery(actionsTypes.LOGIN_START, loginStart);
}

// function* otpGenStart(action) {
//   
//   try {
//     const response = yield AuthService.login({
//       email: action.payload.email
//     });

//     if (response.data && response.data.statusCode === 200) { 
//       yield put(actions.genOtpSuccess(response.data));
//     } else {
//       yield put(actions.genOtpFailure("Invalid Username/Password"));
//     }
//   } catch (err) {
//     
//     let error = err?.response?.data?.message;

//     if (!error) {
//       error = err?.response?.message || "Network error";
//     }
//     yield put(actions.genOtpFailure(error));
//   }
// }

// function* otpGenStartSaga() {
//   yield takeEvery(actionsTypes.OTP_GEN, otpGenStart);
// }

function* signUpStart(action) {
  try {
    let response = ''
    let payload = action.payload;
    let create = payload.create;
    delete payload.create
    if (create) {
      // create user flow
      delete payload.id
      response = yield AuthService.signup(payload);
    } else { 
      response = yield AuthService.editUser(payload);
    }  
  } catch (err) {
    // 
    let error = err?.response?.data?.message;
    if (!error) {
      error = "network error"
    }
    yield put(actions.signupFailure(error));
  }
}

function* signupStartSaga() {
  yield takeEvery(actionsTypes.SIGNUP_START, signUpStart);
}

function* getQueryList(action) {
  try {
    //
    if (action.payload) {
      const page = action.payload?.pageNo;
      const perPage = action.payload?.perPage;
      const search = action.payload?.search;
      const status = action.payload?.statusType;
      let params = {page, perPage, search, status};

      const response = yield AuthService.listQuery(params);
      // 
      if (response?.data?.statusCode === 200) {
        //
        yield put(actions.listQuerySuccess(response.data));
      } else {
        yield put(actions.listQueryFailure("network error"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    yield put(actions.listQueryFailure(error));
  }
}
function* getQueryListSaga() {
  yield takeEvery(actionsTypes.LIST_QUERY_START, getQueryList);
}

function* manageConfig(action){
  try {

    let response;
    let payload = action.payload;
    let create = payload.create;
    delete payload.create;
    // 
    if (create) {
      // create user flow
      delete payload._id
    }
    response = yield AuthService.manageConfig(payload);
    if (response?.data.statusCode === 200) {
      //
      yield put(actions.manageConfigSuccess(response.data));
    } else {
      yield put(actions.manageConfigFailure("network error"));
    }
  } catch (err) {
    // 
    let error = err?.response?.data?.message;
    if (!error) {
      error = "network error"
    }
    yield put(actions.signupFailure(error));
  }
}

function* manageConfigSaga() {
  yield takeEvery(actionsTypes.MANAGE_CONFIG_START, manageConfig);
}

function* getConfig(action){
  try {
    let response = yield AuthService.getConfig();
    if (response?.data.statusCode === 200) {
      //
      yield put(actions.getConfigSuccess(response.data));
    } else {
      yield put(actions.getConfigFailure("network error"));
    }
  } catch (err) {
    // 
    let error = err?.response?.data?.message;
    if (!error) {
      error = "network error"
    }
    yield put(actions.getConfigFailure(error));
  }
}

function* getConfigSaga() {
  yield takeEvery(actionsTypes.GET_CONFIG_START, getConfig);
}

export function* authSaga() {
  yield all([fork(loginStartSaga), fork(signupStartSaga), fork(getQueryListSaga),fork(manageConfigSaga),fork(getConfigSaga)]);
}
